// src/pages/SignedOutPage.tsx
//
// ★★ ADR 0015 — WHERE A DELIBERATE SIGN-OUT LANDS. It must NOT redirect to single sign-on by itself: an identity provider that still
// holds the person's own session would sign them straight back in, and "Sign out" would appear to do nothing, in a loop. So this
// page says what happened and offers one button, and only pressing it starts single sign-on again.
//
// ⚠ This ends the PRS session, not the identity provider's. Anyone on a shared machine who needs the provider's session ended too
// must sign out of it there. The page says so.
import { useState } from 'react'
import { SgdsButton } from '@govtechsg/sgds-web-component/react'
import { SsoRedirect } from '../components/SsoRedirect'
import { useDocumentTitle } from '../lib/crumbs'

export function SignedOutPage() {
  useDocumentTitle('Signed out')
  const [signingIn, setSigningIn] = useState(false)
  if (signingIn) return <SsoRedirect />
  return (
    <main className="min-h-screen grid place-items-center px-6">
      <div className="pt-card max-w-lg flex flex-col gap-4">
        <h1 className="text-3xl">You have signed out</h1>
        <p className="text-[var(--sgds-body-color-subtle)]">
          You are signed out of PRS. Your single sign-on session with your organisation may still be open. If you are on a shared computer,
          sign out there as well.
        </p>
        <div>
          <SgdsButton variant="primary" type="button" onClick={() => setSigningIn(true)}>
            Sign in
          </SgdsButton>
        </div>
      </div>
    </main>
  )
}
